import React, { useState } from 'react'
import ProgramAccordion from './ProgramAccordion'
import { useLoadingIds } from '../../../hooks/useLoadingIds'
import useLoadingContext from '../../../hooks/useLoadingContext'
import { useMountEffect } from '../../../hooks/useMountEffect'
import { useAppSnackbar } from '../../../hooks/useAppSnackbar'
import {
  FetchDirectorFinancialDetailsResponsePrograms,
  financialApi,
} from '../../../api/swagger'
import LoadingProgress from '../../Elements/LoadingProgress'

interface DirectorDetailsProps {
  communityKey: number
  actorKey: number
}

const DirectorDetails: React.FC<DirectorDetailsProps> = ({
  communityKey,
  actorKey,
}) => {
  const { handleError } = useAppSnackbar()
  const {
    Financials: {
      fetchDirectorFinancialDetails: fetchDirectorFinancialDetailsLoadingId,
    },
  } = useLoadingIds()

  const [programInfo, setProgramInfo] = useState<
    FetchDirectorFinancialDetailsResponsePrograms[]
  >([])

  const fetchDirectorFinancialDetails = async () => {
    try {
      const { programs } = await financialApi.fetchDirectorFinancialDetails({
        communityKey,
        actorKey,
      })
      setProgramInfo(programs)
    } catch (error) {
      await handleError(error)
    }
  }

  const { triggerFetch, isLoading } = useLoadingContext({
    loadingId: fetchDirectorFinancialDetailsLoadingId + actorKey.toString(),
    asyncFunction: fetchDirectorFinancialDetails,
  })

  useMountEffect(triggerFetch)

  return (
    <>
      {isLoading ? (
        <LoadingProgress />
      ) : programInfo.length > 0 ? (
        programInfo.map(
          (
            {
              programType,
              tutors,
              familyOwesTutor,
              tutorOwesDirector,
              familiesOweDirector,
              tutorCount,
              familyCount,
            },
            index
          ) => (
            <ProgramAccordion
              key={`${programType}-${index}`}
              program={{
                programType,
                tutors,
                familyOwesTutor,
                tutorOwesDirector,
                tutorCount,
                familyCount,
                familiesOweDirector,
              }}
            />
          )
        )
      ) : null}
    </>
  )
}

export default DirectorDetails
